import React, { useMemo } from "react";
import { getI18n, withI18n } from "react-i18next";
import { withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import qs from "query-string";
import {
  redirectToLogin,
  redirectToHome,
  redirectToRegister,
  redirectToCWBLabs,
  getRegisterRedirect
} from "shared/helpers";
import CWBLabsLogo from "images/cwblabs.svg";
import CWBLabsLogoMobile from "images/icon-cwb-logo.svg";
import LogoTWB from "images/logo-twb.svg";
import LogoTWBPng from "images/logo-twb.png";
import LogoCWB from "images/logo-cwb.svg";
import LogoPWB from "images/logo-pwb.svg";
import LogoTWBShort from "images/logo-twb-short.svg";
import LogoCWBShort from "images/logo-cwb-short.svg";
import LogoPWBShort from "images/logo-pwb-short.svg";
import { useScreenSize } from '../hooks';

const isMobile = window.matchMedia("(max-width: 375px)").matches;
const BREAKPOINT_SHORT_LOGO = 760;

const Header = ({ location, t }) => {
  const isLangSpanish = getI18n().language === "es";
  const queryString = qs.parse(location.search);

  const targetUrl = useMemo(() => {
    return getRegisterRedirect(location)
  }, [location]);

  const [screenWidth] = useScreenSize();

  const signupRedirect = (ev) => {
    ev.preventDefault();
    window.location.href = getRegisterRedirect(location);
  };

  const isRootRoute = () => {
    return location.pathname.toString().split('/').length <= 2
  }

  const loginRedirect = (ev) => {
    ev.preventDefault();
    if (isRootRoute())
      redirectToLogin(location.search)
    else
      redirectToLogin()
  }

  if (queryString.cwblabs) {
    return (
      <Wrapper isCWBLabs>
        <Container isCWBLabs>
          <img
            src={isMobile ? CWBLabsLogoMobile : CWBLabsLogo}
            alt="CWBLabs Logo"
            onClick={() => redirectToCWBLabs(isLangSpanish)}
            style={{ cursor: "pointer" }}
          />
        </Container>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Container>
        <LogoLink href="https://www.theworkbook.com">
          <LogoImage
            src={screenWidth > BREAKPOINT_SHORT_LOGO ? LogoTWB : LogoTWBShort}
            style={(screenWidth > BREAKPOINT_SHORT_LOGO ? {minHeight:'42px'} : {})}
            alt="The Workbook Logo"
          />
        </LogoLink>
        <ProductUl>
          <ProductLi>
            <LogoLink href={CWB_API_ENV.domain.replace("www.c","home.c")}>
              <LogoImage
                src={screenWidth > BREAKPOINT_SHORT_LOGO ? LogoCWB : LogoCWBShort}
                alt="Casting Workbook Logo"
              />
            </LogoLink>
          </ProductLi>
          <ProductLi>
            <LogoLink href="https://www.theworkbook.com/production/" target="_blank">
              <LogoImage
                src={screenWidth > BREAKPOINT_SHORT_LOGO ? LogoPWB : LogoPWBShort}
                alt="Production Workbook Logo"
              />
            </LogoLink>
          </ProductLi>
        </ProductUl>
        <LoginDiv>
          {!location.pathname.toString().toLowerCase().endsWith("/go") &&
            (
              location.pathname.toString().toLowerCase().startsWith("/login") ? (
                <LoginButton className="cwb-btn-primary" href={targetUrl} onClick={signupRedirect}>
                  {t("Sign up")}
                </LoginButton>
              ) : (
                <LoginButton className="cwb-btn-primary" href={`${CWB_API_ENV.domain}/login${location.search || ""}`} onClick={loginRedirect}>
                  {t("Login")}
                </LoginButton>
              )
            )
          }
        </LoginDiv>
      </Container>
    </Wrapper>
  );
};

export default withI18n()(withRouter(Header));

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(p) =>
    p.isCWBLabs
      ? css`
          height: 80px;
          background-color: #040f1c;
        `
      : css`
          height: 60px;
          background-color: ${(p) => p.theme.white};
          box-shadow: 0 2px 4px 0 rgba(218, 218, 218, 0.5);
        `}
`;

const LogoLink = styled.a`

`
const LogoImage = styled.img`
  height: 40px;
  margin-right: 40px;

  @media all and (max-width: 360px) {
    margin-right: 10px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  width: 65%;
  min-width: 800px;

  @media all and (max-width: 820px) {
    min-width: 280px;
    width: 100%;
    padding: 0 10px;
    // justify-content: start;
  }

  // @media all and (max-width: 520px) {
  //   width: 90%;
  //   .cwb-btn-primary {
  //     padding: 10px;
  //   }
  // }

  // @media all and (max-width: 920px) {
  //   width: 80%;
  // }

  // @media all and (max-width: 520px) {
  //   width: 90%;
  //   .cwb-btn-primary {
  //     padding: 10px;
  //   }
  // }

  ${(p) =>
    p.isCWBLabs &&
    css`
      width: 100%;
      padding: 0 32px;

      @media (max-width: 375px) {
        width: 100%;
      }
    `}
`;

const ProductUl = styled.ul`
  display: flex;
  flex-flow: nowrap row;
  list-style: none;
  margin-bottom: 0;
  padding: 0;
  margin-left: -60px;
  @media all and (max-width: 820px) {
    margin-left: 0;
  }
  
  @media all and (max-width: ${BREAKPOINT_SHORT_LOGO}px) {
    margin-right: auto;
  }
`;

const ProductLi = styled.li`
  padding: 8px 0;
`;

const LoginDiv = styled.div`
  font-size: 11px;
  letter-spacing: 0.21px;
`;

const LoginButton = styled.a`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 5px;
  background: #0f9bf0;
  color: white !important;
  padding: 10px 15px 10px 15px;
  font-size: 16px;
  border: 0;

  &:hover {
    background: #0892e5 !important;
    border: 0 !important;
    color: white !important;
  }

  &:active {
    background: #0584d7 !important;
    border: 0 !important;
    color: white !important;
  }

  &:disabled {
    border-color: #d5d5d5;
    background: white;
    color: #444a56;
    opacity: 0.4;
  }
`;

const RegisterLink = styled.a`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 5px;

  padding: 10px 15px 10px 15px;

  background: none;
  color: #0a1f44 !important;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  cursor: pointer;

  &:hover {
    color: #2ed2ff !important;
  }

  &:disabled {
    border-color: #d5d5d5;
    background: white;
    color: #444a56;
    opacity: 0.4;
  }

  @media (max-width: 475px) {
    font-size: 12px;
  }
`;
